export default __webpack_public_path__ + "static/media/portis.90689246.webp";